import { Card } from '@ui/card';
import styles from './index.module.sass';
import { Market, SimplePrice } from '@@/mixing/ts/analytic.types';
import cn from 'classnames';
import { useEffect, useState } from 'react';
import { ButtonPrimary } from '@/shared/ui/button';
import { Skeleton } from 'antd';
import { UniversalLoader } from '@/modules/common/components/universal-loader';
import spicaGreySvg from '@/modules/mixing/images/spica-grey.svg';
type FormattedTime = string;

export function PriceCurrentCard({
  tonPrice,
  onButtonClick,
  className,
  loading,
}: IPriceCurrentCard) {
  const [formattedDate, setFormattedDate] = useState<FormattedTime>('');

  const months: string[] = [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря',
  ];

  const formatTime = (): FormattedTime => {
    const now = new Date();
    const monthIndex = now.getMonth();

    return `${now.getDate()} ${months[monthIndex]} ${now.getHours()}:${String(
      now.getMinutes(),
    ).padStart(2, '0')}`;
  };

  useEffect(() => {
    const updateClock = (): void => {
      setFormattedDate(formatTime());
    };

    updateClock();
    const intervalId = setInterval(updateClock, 30000);

    return (): void => clearInterval(intervalId);
  }, []);

  return (
    <Card className={cn(styles.root, className && className)}>
      {loading ? (
        <UniversalLoader
          title={
            <span>
              подождите, пожалуйста несколько секунд. <br /> Идет пересчет стоимостей
            </span>
          }
        />
      ) : (
        // <Skeleton loading={true} paragraph={true} active={true} />
        <div className={styles.body}>
          <div className={styles.date}>
            <img src={spicaGreySvg} />
            {formattedDate}
          </div>
          <div className={styles.label}>
            стоимость ваших складов <br /> без использования миксования
          </div>
          <div className={styles.bottomArea}>
            <span className={styles.price}>{tonPrice} </span>

            <ButtonPrimary
              className={styles.detailsButton}
              onClick={onButtonClick}
              label="подробнее"
            />
          </div>
        </div>
      )}
    </Card>
  );
}

export interface IPriceCurrentCard {
  tonPrice: string;
  onButtonClick: () => void;
  className: string;
  loading: boolean;
}
